export enum VoidFlag{
  Available = 0,
  Unavailable = 1
}
